// extracted by mini-css-extract-plugin
module.exports = {"dummy":"draggingGroup_dummy__363lS","item":"draggingGroup_item__1D-XA"};